/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as WelcomeRouteImport } from "./routes/welcome";
import { Route as VerifyEmailSentRouteImport } from "./routes/verify-email-sent";
import { Route as ResetPasswordRouteImport } from "./routes/reset-password";
import { Route as RegisterRouteImport } from "./routes/register";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password";
import { Route as AcceptInviteRouteImport } from "./routes/accept-invite";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthCallbackRouteImport } from "./routes/auth.callback";
import { Route as AuthenticatedDashboardRouteImport } from "./routes/_authenticated/dashboard";

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const VerifyEmailSentRoute = VerifyEmailSentRouteImport.update({
  id: "/verify-email-sent",
  path: "/verify-email-sent",
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const RegisterRoute = RegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: "/accept-invite",
  path: "/accept-invite",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/verify-email-sent": typeof VerifyEmailSentRoute;
  "/welcome": typeof WelcomeRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/auth/callback": typeof AuthCallbackRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/verify-email-sent": typeof VerifyEmailSentRoute;
  "/welcome": typeof WelcomeRoute;
  "/dashboard": typeof AuthenticatedDashboardRoute;
  "/auth/callback": typeof AuthCallbackRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/accept-invite": typeof AcceptInviteRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/verify-email-sent": typeof VerifyEmailSentRoute;
  "/welcome": typeof WelcomeRoute;
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute;
  "/auth/callback": typeof AuthCallbackRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify-email-sent"
    | "/welcome"
    | "/dashboard"
    | "/auth/callback";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify-email-sent"
    | "/welcome"
    | "/dashboard"
    | "/auth/callback";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify-email-sent"
    | "/welcome"
    | "/_authenticated/dashboard"
    | "/auth/callback";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AcceptInviteRoute: typeof AcceptInviteRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LoginRoute: typeof LoginRoute;
  RegisterRoute: typeof RegisterRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  VerifyEmailSentRoute: typeof VerifyEmailSentRoute;
  WelcomeRoute: typeof WelcomeRoute;
  AuthCallbackRoute: typeof AuthCallbackRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome";
      path: "/welcome";
      fullPath: "/welcome";
      preLoaderRoute: typeof WelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/verify-email-sent": {
      id: "/verify-email-sent";
      path: "/verify-email-sent";
      fullPath: "/verify-email-sent";
      preLoaderRoute: typeof VerifyEmailSentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/register": {
      id: "/register";
      path: "/register";
      fullPath: "/register";
      preLoaderRoute: typeof RegisterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/accept-invite": {
      id: "/accept-invite";
      path: "/accept-invite";
      fullPath: "/accept-invite";
      preLoaderRoute: typeof AcceptInviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/auth/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailSentRoute: VerifyEmailSentRoute,
  WelcomeRoute: WelcomeRoute,
  AuthCallbackRoute: AuthCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
